export const API = Object.freeze({
  BASE_URL: 'https://jsonplaceholder.typicode.com/',
  USER: '/users',
})

export const UI_CONSTANTS = Object.freeze({
  USER: 'user',
  AUTHORIZED_USER: 'auth_user',
  UPDATE_LOADS: 'update_load',
  SET_SOCKET_CONNECTION_STATUS: 'socketConnectionSuccess',
})

export const FF_SESSION_KEY = 'ff_session'
